import { render } from "./incoming-call.vue?vue&type=template&id=1591f049"
import script from "./incoming-call.vue?vue&type=script&lang=js"
export * from "./incoming-call.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__